/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as R403RouteImport } from './routes/403'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthUserSettingsRouteImport } from './routes/_auth/user-settings'
import { Route as AuthReleaseFromCaseRouteImport } from './routes/_auth/release-from-case'
import { Route as AuthMuiLicenseTestRouteImport } from './routes/_auth/mui-license-test'
import { Route as AuthLiveOrRouteImport } from './routes/_auth/live-or'
import { Route as AuthInsightsRouteImport } from './routes/_auth/insights'
import { Route as AuthHelpSupportRouteImport } from './routes/_auth/help-support'
import { Route as AuthFindAssetRouteImport } from './routes/_auth/find-asset'
import { Route as AuthCaseCartAssemblyDetailRouteImport } from './routes/_auth/case-cart-assembly-detail'
import { Route as AuthCaseCartAssemblyRouteImport } from './routes/_auth/case-cart-assembly'
import { Route as AuthAssignToCaseRouteImport } from './routes/_auth/assign-to-case'
import { Route as AuthAssembleTrayRouteImport } from './routes/_auth/assemble-tray'
import { Route as AuthEntityManagementRouteRouteImport } from './routes/_auth/entity-management/route'
import { Route as AuthCaseScheduleRouteRouteImport } from './routes/_auth/case-schedule/route'
import { Route as AuthAdminRouteRouteImport } from './routes/_auth/_admin/route'
import { Route as AuthEntityManagementIndexRouteImport } from './routes/_auth/entity-management/index'
import { Route as AuthCaseScheduleIndexRouteImport } from './routes/_auth/case-schedule/index'
import { Route as AuthEntityManagementUntrackedAssetCatalogRouteImport } from './routes/_auth/entity-management/untracked-asset-catalog'
import { Route as AuthEntityManagementTrackedAssetsRouteImport } from './routes/_auth/entity-management/tracked-assets'
import { Route as AuthEntityManagementTrackedAssetCatalogRouteImport } from './routes/_auth/entity-management/tracked-asset-catalog'
import { Route as AuthEntityManagementSurgeonsRouteImport } from './routes/_auth/entity-management/surgeons'
import { Route as AuthEntityManagementPreferenceCardsRouteImport } from './routes/_auth/entity-management/preference-cards'
import { Route as AuthEntityManagementLocationsRouteImport } from './routes/_auth/entity-management/locations'
import { Route as AuthEntityManagementFacilitiesRouteImport } from './routes/_auth/entity-management/facilities'
import { Route as AuthEntityManagementCountSheetsRouteImport } from './routes/_auth/entity-management/count-sheets'
import { Route as AuthEntityManagementCaseTypesRouteImport } from './routes/_auth/entity-management/case-types'
import { Route as AuthCaseScheduleCaseDetailRouteImport } from './routes/_auth/case-schedule/case-detail'
import { Route as AuthCaseScheduleBuildCartRouteImport } from './routes/_auth/case-schedule/build-cart'
import { Route as AuthAdminUserRolesRouteImport } from './routes/_auth/_admin/user-roles'
import { Route as AuthAdminTrackerSetupRouteImport } from './routes/_auth/_admin/tracker-setup'
import { Route as AuthAdminCobotSetupRouteImport } from './routes/_auth/_admin/cobot-setup'

const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthUserSettingsRoute = AuthUserSettingsRouteImport.update({
  id: '/user-settings',
  path: '/user-settings',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthReleaseFromCaseRoute = AuthReleaseFromCaseRouteImport.update({
  id: '/release-from-case',
  path: '/release-from-case',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthMuiLicenseTestRoute = AuthMuiLicenseTestRouteImport.update({
  id: '/mui-license-test',
  path: '/mui-license-test',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLiveOrRoute = AuthLiveOrRouteImport.update({
  id: '/live-or',
  path: '/live-or',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthInsightsRoute = AuthInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthHelpSupportRoute = AuthHelpSupportRouteImport.update({
  id: '/help-support',
  path: '/help-support',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthFindAssetRoute = AuthFindAssetRouteImport.update({
  id: '/find-asset',
  path: '/find-asset',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthCaseCartAssemblyDetailRoute =
  AuthCaseCartAssemblyDetailRouteImport.update({
    id: '/case-cart-assembly-detail',
    path: '/case-cart-assembly-detail',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthCaseCartAssemblyRoute = AuthCaseCartAssemblyRouteImport.update({
  id: '/case-cart-assembly',
  path: '/case-cart-assembly',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthAssignToCaseRoute = AuthAssignToCaseRouteImport.update({
  id: '/assign-to-case',
  path: '/assign-to-case',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthAssembleTrayRoute = AuthAssembleTrayRouteImport.update({
  id: '/assemble-tray',
  path: '/assemble-tray',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthEntityManagementRouteRoute =
  AuthEntityManagementRouteRouteImport.update({
    id: '/entity-management',
    path: '/entity-management',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthCaseScheduleRouteRoute = AuthCaseScheduleRouteRouteImport.update({
  id: '/case-schedule',
  path: '/case-schedule',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthAdminRouteRoute = AuthAdminRouteRouteImport.update({
  id: '/_admin',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthEntityManagementIndexRoute =
  AuthEntityManagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthEntityManagementRouteRoute,
  } as any)
const AuthCaseScheduleIndexRoute = AuthCaseScheduleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthCaseScheduleRouteRoute,
} as any)
const AuthEntityManagementUntrackedAssetCatalogRoute =
  AuthEntityManagementUntrackedAssetCatalogRouteImport.update({
    id: '/untracked-asset-catalog',
    path: '/untracked-asset-catalog',
    getParentRoute: () => AuthEntityManagementRouteRoute,
  } as any)
const AuthEntityManagementTrackedAssetsRoute =
  AuthEntityManagementTrackedAssetsRouteImport.update({
    id: '/tracked-assets',
    path: '/tracked-assets',
    getParentRoute: () => AuthEntityManagementRouteRoute,
  } as any)
const AuthEntityManagementTrackedAssetCatalogRoute =
  AuthEntityManagementTrackedAssetCatalogRouteImport.update({
    id: '/tracked-asset-catalog',
    path: '/tracked-asset-catalog',
    getParentRoute: () => AuthEntityManagementRouteRoute,
  } as any)
const AuthEntityManagementSurgeonsRoute =
  AuthEntityManagementSurgeonsRouteImport.update({
    id: '/surgeons',
    path: '/surgeons',
    getParentRoute: () => AuthEntityManagementRouteRoute,
  } as any)
const AuthEntityManagementPreferenceCardsRoute =
  AuthEntityManagementPreferenceCardsRouteImport.update({
    id: '/preference-cards',
    path: '/preference-cards',
    getParentRoute: () => AuthEntityManagementRouteRoute,
  } as any)
const AuthEntityManagementLocationsRoute =
  AuthEntityManagementLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => AuthEntityManagementRouteRoute,
  } as any)
const AuthEntityManagementFacilitiesRoute =
  AuthEntityManagementFacilitiesRouteImport.update({
    id: '/facilities',
    path: '/facilities',
    getParentRoute: () => AuthEntityManagementRouteRoute,
  } as any)
const AuthEntityManagementCountSheetsRoute =
  AuthEntityManagementCountSheetsRouteImport.update({
    id: '/count-sheets',
    path: '/count-sheets',
    getParentRoute: () => AuthEntityManagementRouteRoute,
  } as any)
const AuthEntityManagementCaseTypesRoute =
  AuthEntityManagementCaseTypesRouteImport.update({
    id: '/case-types',
    path: '/case-types',
    getParentRoute: () => AuthEntityManagementRouteRoute,
  } as any)
const AuthCaseScheduleCaseDetailRoute =
  AuthCaseScheduleCaseDetailRouteImport.update({
    id: '/case-detail',
    path: '/case-detail',
    getParentRoute: () => AuthCaseScheduleRouteRoute,
  } as any)
const AuthCaseScheduleBuildCartRoute =
  AuthCaseScheduleBuildCartRouteImport.update({
    id: '/build-cart',
    path: '/build-cart',
    getParentRoute: () => AuthCaseScheduleRouteRoute,
  } as any)
const AuthAdminUserRolesRoute = AuthAdminUserRolesRouteImport.update({
  id: '/user-roles',
  path: '/user-roles',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminTrackerSetupRoute = AuthAdminTrackerSetupRouteImport.update({
  id: '/tracker-setup',
  path: '/tracker-setup',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminCobotSetupRoute = AuthAdminCobotSetupRouteImport.update({
  id: '/cobot-setup',
  path: '/cobot-setup',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/case-schedule': typeof AuthCaseScheduleRouteRouteWithChildren
  '/entity-management': typeof AuthEntityManagementRouteRouteWithChildren
  '/assemble-tray': typeof AuthAssembleTrayRoute
  '/assign-to-case': typeof AuthAssignToCaseRoute
  '/case-cart-assembly': typeof AuthCaseCartAssemblyRoute
  '/case-cart-assembly-detail': typeof AuthCaseCartAssemblyDetailRoute
  '/find-asset': typeof AuthFindAssetRoute
  '/help-support': typeof AuthHelpSupportRoute
  '/insights': typeof AuthInsightsRoute
  '/live-or': typeof AuthLiveOrRoute
  '/mui-license-test': typeof AuthMuiLicenseTestRoute
  '/release-from-case': typeof AuthReleaseFromCaseRoute
  '/user-settings': typeof AuthUserSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/cobot-setup': typeof AuthAdminCobotSetupRoute
  '/tracker-setup': typeof AuthAdminTrackerSetupRoute
  '/user-roles': typeof AuthAdminUserRolesRoute
  '/case-schedule/build-cart': typeof AuthCaseScheduleBuildCartRoute
  '/case-schedule/case-detail': typeof AuthCaseScheduleCaseDetailRoute
  '/entity-management/case-types': typeof AuthEntityManagementCaseTypesRoute
  '/entity-management/count-sheets': typeof AuthEntityManagementCountSheetsRoute
  '/entity-management/facilities': typeof AuthEntityManagementFacilitiesRoute
  '/entity-management/locations': typeof AuthEntityManagementLocationsRoute
  '/entity-management/preference-cards': typeof AuthEntityManagementPreferenceCardsRoute
  '/entity-management/surgeons': typeof AuthEntityManagementSurgeonsRoute
  '/entity-management/tracked-asset-catalog': typeof AuthEntityManagementTrackedAssetCatalogRoute
  '/entity-management/tracked-assets': typeof AuthEntityManagementTrackedAssetsRoute
  '/entity-management/untracked-asset-catalog': typeof AuthEntityManagementUntrackedAssetCatalogRoute
  '/case-schedule/': typeof AuthCaseScheduleIndexRoute
  '/entity-management/': typeof AuthEntityManagementIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/assemble-tray': typeof AuthAssembleTrayRoute
  '/assign-to-case': typeof AuthAssignToCaseRoute
  '/case-cart-assembly': typeof AuthCaseCartAssemblyRoute
  '/case-cart-assembly-detail': typeof AuthCaseCartAssemblyDetailRoute
  '/find-asset': typeof AuthFindAssetRoute
  '/help-support': typeof AuthHelpSupportRoute
  '/insights': typeof AuthInsightsRoute
  '/live-or': typeof AuthLiveOrRoute
  '/mui-license-test': typeof AuthMuiLicenseTestRoute
  '/release-from-case': typeof AuthReleaseFromCaseRoute
  '/user-settings': typeof AuthUserSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/cobot-setup': typeof AuthAdminCobotSetupRoute
  '/tracker-setup': typeof AuthAdminTrackerSetupRoute
  '/user-roles': typeof AuthAdminUserRolesRoute
  '/case-schedule/build-cart': typeof AuthCaseScheduleBuildCartRoute
  '/case-schedule/case-detail': typeof AuthCaseScheduleCaseDetailRoute
  '/entity-management/case-types': typeof AuthEntityManagementCaseTypesRoute
  '/entity-management/count-sheets': typeof AuthEntityManagementCountSheetsRoute
  '/entity-management/facilities': typeof AuthEntityManagementFacilitiesRoute
  '/entity-management/locations': typeof AuthEntityManagementLocationsRoute
  '/entity-management/preference-cards': typeof AuthEntityManagementPreferenceCardsRoute
  '/entity-management/surgeons': typeof AuthEntityManagementSurgeonsRoute
  '/entity-management/tracked-asset-catalog': typeof AuthEntityManagementTrackedAssetCatalogRoute
  '/entity-management/tracked-assets': typeof AuthEntityManagementTrackedAssetsRoute
  '/entity-management/untracked-asset-catalog': typeof AuthEntityManagementUntrackedAssetCatalogRoute
  '/case-schedule': typeof AuthCaseScheduleIndexRoute
  '/entity-management': typeof AuthEntityManagementIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/403': typeof R403Route
  '/_auth/_admin': typeof AuthAdminRouteRouteWithChildren
  '/_auth/case-schedule': typeof AuthCaseScheduleRouteRouteWithChildren
  '/_auth/entity-management': typeof AuthEntityManagementRouteRouteWithChildren
  '/_auth/assemble-tray': typeof AuthAssembleTrayRoute
  '/_auth/assign-to-case': typeof AuthAssignToCaseRoute
  '/_auth/case-cart-assembly': typeof AuthCaseCartAssemblyRoute
  '/_auth/case-cart-assembly-detail': typeof AuthCaseCartAssemblyDetailRoute
  '/_auth/find-asset': typeof AuthFindAssetRoute
  '/_auth/help-support': typeof AuthHelpSupportRoute
  '/_auth/insights': typeof AuthInsightsRoute
  '/_auth/live-or': typeof AuthLiveOrRoute
  '/_auth/mui-license-test': typeof AuthMuiLicenseTestRoute
  '/_auth/release-from-case': typeof AuthReleaseFromCaseRoute
  '/_auth/user-settings': typeof AuthUserSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_auth/_admin/cobot-setup': typeof AuthAdminCobotSetupRoute
  '/_auth/_admin/tracker-setup': typeof AuthAdminTrackerSetupRoute
  '/_auth/_admin/user-roles': typeof AuthAdminUserRolesRoute
  '/_auth/case-schedule/build-cart': typeof AuthCaseScheduleBuildCartRoute
  '/_auth/case-schedule/case-detail': typeof AuthCaseScheduleCaseDetailRoute
  '/_auth/entity-management/case-types': typeof AuthEntityManagementCaseTypesRoute
  '/_auth/entity-management/count-sheets': typeof AuthEntityManagementCountSheetsRoute
  '/_auth/entity-management/facilities': typeof AuthEntityManagementFacilitiesRoute
  '/_auth/entity-management/locations': typeof AuthEntityManagementLocationsRoute
  '/_auth/entity-management/preference-cards': typeof AuthEntityManagementPreferenceCardsRoute
  '/_auth/entity-management/surgeons': typeof AuthEntityManagementSurgeonsRoute
  '/_auth/entity-management/tracked-asset-catalog': typeof AuthEntityManagementTrackedAssetCatalogRoute
  '/_auth/entity-management/tracked-assets': typeof AuthEntityManagementTrackedAssetsRoute
  '/_auth/entity-management/untracked-asset-catalog': typeof AuthEntityManagementUntrackedAssetCatalogRoute
  '/_auth/case-schedule/': typeof AuthCaseScheduleIndexRoute
  '/_auth/entity-management/': typeof AuthEntityManagementIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/403'
    | '/case-schedule'
    | '/entity-management'
    | '/assemble-tray'
    | '/assign-to-case'
    | '/case-cart-assembly'
    | '/case-cart-assembly-detail'
    | '/find-asset'
    | '/help-support'
    | '/insights'
    | '/live-or'
    | '/mui-license-test'
    | '/release-from-case'
    | '/user-settings'
    | '/auth/callback'
    | '/cobot-setup'
    | '/tracker-setup'
    | '/user-roles'
    | '/case-schedule/build-cart'
    | '/case-schedule/case-detail'
    | '/entity-management/case-types'
    | '/entity-management/count-sheets'
    | '/entity-management/facilities'
    | '/entity-management/locations'
    | '/entity-management/preference-cards'
    | '/entity-management/surgeons'
    | '/entity-management/tracked-asset-catalog'
    | '/entity-management/tracked-assets'
    | '/entity-management/untracked-asset-catalog'
    | '/case-schedule/'
    | '/entity-management/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/403'
    | '/assemble-tray'
    | '/assign-to-case'
    | '/case-cart-assembly'
    | '/case-cart-assembly-detail'
    | '/find-asset'
    | '/help-support'
    | '/insights'
    | '/live-or'
    | '/mui-license-test'
    | '/release-from-case'
    | '/user-settings'
    | '/auth/callback'
    | '/cobot-setup'
    | '/tracker-setup'
    | '/user-roles'
    | '/case-schedule/build-cart'
    | '/case-schedule/case-detail'
    | '/entity-management/case-types'
    | '/entity-management/count-sheets'
    | '/entity-management/facilities'
    | '/entity-management/locations'
    | '/entity-management/preference-cards'
    | '/entity-management/surgeons'
    | '/entity-management/tracked-asset-catalog'
    | '/entity-management/tracked-assets'
    | '/entity-management/untracked-asset-catalog'
    | '/case-schedule'
    | '/entity-management'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/403'
    | '/_auth/_admin'
    | '/_auth/case-schedule'
    | '/_auth/entity-management'
    | '/_auth/assemble-tray'
    | '/_auth/assign-to-case'
    | '/_auth/case-cart-assembly'
    | '/_auth/case-cart-assembly-detail'
    | '/_auth/find-asset'
    | '/_auth/help-support'
    | '/_auth/insights'
    | '/_auth/live-or'
    | '/_auth/mui-license-test'
    | '/_auth/release-from-case'
    | '/_auth/user-settings'
    | '/auth/callback'
    | '/_auth/_admin/cobot-setup'
    | '/_auth/_admin/tracker-setup'
    | '/_auth/_admin/user-roles'
    | '/_auth/case-schedule/build-cart'
    | '/_auth/case-schedule/case-detail'
    | '/_auth/entity-management/case-types'
    | '/_auth/entity-management/count-sheets'
    | '/_auth/entity-management/facilities'
    | '/_auth/entity-management/locations'
    | '/_auth/entity-management/preference-cards'
    | '/_auth/entity-management/surgeons'
    | '/_auth/entity-management/tracked-asset-catalog'
    | '/_auth/entity-management/tracked-assets'
    | '/_auth/entity-management/untracked-asset-catalog'
    | '/_auth/case-schedule/'
    | '/_auth/entity-management/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  R403Route: typeof R403Route
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/user-settings': {
      id: '/_auth/user-settings'
      path: '/user-settings'
      fullPath: '/user-settings'
      preLoaderRoute: typeof AuthUserSettingsRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/release-from-case': {
      id: '/_auth/release-from-case'
      path: '/release-from-case'
      fullPath: '/release-from-case'
      preLoaderRoute: typeof AuthReleaseFromCaseRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/mui-license-test': {
      id: '/_auth/mui-license-test'
      path: '/mui-license-test'
      fullPath: '/mui-license-test'
      preLoaderRoute: typeof AuthMuiLicenseTestRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/live-or': {
      id: '/_auth/live-or'
      path: '/live-or'
      fullPath: '/live-or'
      preLoaderRoute: typeof AuthLiveOrRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/insights': {
      id: '/_auth/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof AuthInsightsRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/help-support': {
      id: '/_auth/help-support'
      path: '/help-support'
      fullPath: '/help-support'
      preLoaderRoute: typeof AuthHelpSupportRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/find-asset': {
      id: '/_auth/find-asset'
      path: '/find-asset'
      fullPath: '/find-asset'
      preLoaderRoute: typeof AuthFindAssetRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/case-cart-assembly-detail': {
      id: '/_auth/case-cart-assembly-detail'
      path: '/case-cart-assembly-detail'
      fullPath: '/case-cart-assembly-detail'
      preLoaderRoute: typeof AuthCaseCartAssemblyDetailRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/case-cart-assembly': {
      id: '/_auth/case-cart-assembly'
      path: '/case-cart-assembly'
      fullPath: '/case-cart-assembly'
      preLoaderRoute: typeof AuthCaseCartAssemblyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/assign-to-case': {
      id: '/_auth/assign-to-case'
      path: '/assign-to-case'
      fullPath: '/assign-to-case'
      preLoaderRoute: typeof AuthAssignToCaseRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/assemble-tray': {
      id: '/_auth/assemble-tray'
      path: '/assemble-tray'
      fullPath: '/assemble-tray'
      preLoaderRoute: typeof AuthAssembleTrayRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/entity-management': {
      id: '/_auth/entity-management'
      path: '/entity-management'
      fullPath: '/entity-management'
      preLoaderRoute: typeof AuthEntityManagementRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/case-schedule': {
      id: '/_auth/case-schedule'
      path: '/case-schedule'
      fullPath: '/case-schedule'
      preLoaderRoute: typeof AuthCaseScheduleRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/_admin': {
      id: '/_auth/_admin'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthAdminRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/entity-management/': {
      id: '/_auth/entity-management/'
      path: '/'
      fullPath: '/entity-management/'
      preLoaderRoute: typeof AuthEntityManagementIndexRouteImport
      parentRoute: typeof AuthEntityManagementRouteRoute
    }
    '/_auth/case-schedule/': {
      id: '/_auth/case-schedule/'
      path: '/'
      fullPath: '/case-schedule/'
      preLoaderRoute: typeof AuthCaseScheduleIndexRouteImport
      parentRoute: typeof AuthCaseScheduleRouteRoute
    }
    '/_auth/entity-management/untracked-asset-catalog': {
      id: '/_auth/entity-management/untracked-asset-catalog'
      path: '/untracked-asset-catalog'
      fullPath: '/entity-management/untracked-asset-catalog'
      preLoaderRoute: typeof AuthEntityManagementUntrackedAssetCatalogRouteImport
      parentRoute: typeof AuthEntityManagementRouteRoute
    }
    '/_auth/entity-management/tracked-assets': {
      id: '/_auth/entity-management/tracked-assets'
      path: '/tracked-assets'
      fullPath: '/entity-management/tracked-assets'
      preLoaderRoute: typeof AuthEntityManagementTrackedAssetsRouteImport
      parentRoute: typeof AuthEntityManagementRouteRoute
    }
    '/_auth/entity-management/tracked-asset-catalog': {
      id: '/_auth/entity-management/tracked-asset-catalog'
      path: '/tracked-asset-catalog'
      fullPath: '/entity-management/tracked-asset-catalog'
      preLoaderRoute: typeof AuthEntityManagementTrackedAssetCatalogRouteImport
      parentRoute: typeof AuthEntityManagementRouteRoute
    }
    '/_auth/entity-management/surgeons': {
      id: '/_auth/entity-management/surgeons'
      path: '/surgeons'
      fullPath: '/entity-management/surgeons'
      preLoaderRoute: typeof AuthEntityManagementSurgeonsRouteImport
      parentRoute: typeof AuthEntityManagementRouteRoute
    }
    '/_auth/entity-management/preference-cards': {
      id: '/_auth/entity-management/preference-cards'
      path: '/preference-cards'
      fullPath: '/entity-management/preference-cards'
      preLoaderRoute: typeof AuthEntityManagementPreferenceCardsRouteImport
      parentRoute: typeof AuthEntityManagementRouteRoute
    }
    '/_auth/entity-management/locations': {
      id: '/_auth/entity-management/locations'
      path: '/locations'
      fullPath: '/entity-management/locations'
      preLoaderRoute: typeof AuthEntityManagementLocationsRouteImport
      parentRoute: typeof AuthEntityManagementRouteRoute
    }
    '/_auth/entity-management/facilities': {
      id: '/_auth/entity-management/facilities'
      path: '/facilities'
      fullPath: '/entity-management/facilities'
      preLoaderRoute: typeof AuthEntityManagementFacilitiesRouteImport
      parentRoute: typeof AuthEntityManagementRouteRoute
    }
    '/_auth/entity-management/count-sheets': {
      id: '/_auth/entity-management/count-sheets'
      path: '/count-sheets'
      fullPath: '/entity-management/count-sheets'
      preLoaderRoute: typeof AuthEntityManagementCountSheetsRouteImport
      parentRoute: typeof AuthEntityManagementRouteRoute
    }
    '/_auth/entity-management/case-types': {
      id: '/_auth/entity-management/case-types'
      path: '/case-types'
      fullPath: '/entity-management/case-types'
      preLoaderRoute: typeof AuthEntityManagementCaseTypesRouteImport
      parentRoute: typeof AuthEntityManagementRouteRoute
    }
    '/_auth/case-schedule/case-detail': {
      id: '/_auth/case-schedule/case-detail'
      path: '/case-detail'
      fullPath: '/case-schedule/case-detail'
      preLoaderRoute: typeof AuthCaseScheduleCaseDetailRouteImport
      parentRoute: typeof AuthCaseScheduleRouteRoute
    }
    '/_auth/case-schedule/build-cart': {
      id: '/_auth/case-schedule/build-cart'
      path: '/build-cart'
      fullPath: '/case-schedule/build-cart'
      preLoaderRoute: typeof AuthCaseScheduleBuildCartRouteImport
      parentRoute: typeof AuthCaseScheduleRouteRoute
    }
    '/_auth/_admin/user-roles': {
      id: '/_auth/_admin/user-roles'
      path: '/user-roles'
      fullPath: '/user-roles'
      preLoaderRoute: typeof AuthAdminUserRolesRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/tracker-setup': {
      id: '/_auth/_admin/tracker-setup'
      path: '/tracker-setup'
      fullPath: '/tracker-setup'
      preLoaderRoute: typeof AuthAdminTrackerSetupRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/_admin/cobot-setup': {
      id: '/_auth/_admin/cobot-setup'
      path: '/cobot-setup'
      fullPath: '/cobot-setup'
      preLoaderRoute: typeof AuthAdminCobotSetupRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
  }
}

interface AuthAdminRouteRouteChildren {
  AuthAdminCobotSetupRoute: typeof AuthAdminCobotSetupRoute
  AuthAdminTrackerSetupRoute: typeof AuthAdminTrackerSetupRoute
  AuthAdminUserRolesRoute: typeof AuthAdminUserRolesRoute
}

const AuthAdminRouteRouteChildren: AuthAdminRouteRouteChildren = {
  AuthAdminCobotSetupRoute: AuthAdminCobotSetupRoute,
  AuthAdminTrackerSetupRoute: AuthAdminTrackerSetupRoute,
  AuthAdminUserRolesRoute: AuthAdminUserRolesRoute,
}

const AuthAdminRouteRouteWithChildren = AuthAdminRouteRoute._addFileChildren(
  AuthAdminRouteRouteChildren,
)

interface AuthCaseScheduleRouteRouteChildren {
  AuthCaseScheduleBuildCartRoute: typeof AuthCaseScheduleBuildCartRoute
  AuthCaseScheduleCaseDetailRoute: typeof AuthCaseScheduleCaseDetailRoute
  AuthCaseScheduleIndexRoute: typeof AuthCaseScheduleIndexRoute
}

const AuthCaseScheduleRouteRouteChildren: AuthCaseScheduleRouteRouteChildren = {
  AuthCaseScheduleBuildCartRoute: AuthCaseScheduleBuildCartRoute,
  AuthCaseScheduleCaseDetailRoute: AuthCaseScheduleCaseDetailRoute,
  AuthCaseScheduleIndexRoute: AuthCaseScheduleIndexRoute,
}

const AuthCaseScheduleRouteRouteWithChildren =
  AuthCaseScheduleRouteRoute._addFileChildren(
    AuthCaseScheduleRouteRouteChildren,
  )

interface AuthEntityManagementRouteRouteChildren {
  AuthEntityManagementCaseTypesRoute: typeof AuthEntityManagementCaseTypesRoute
  AuthEntityManagementCountSheetsRoute: typeof AuthEntityManagementCountSheetsRoute
  AuthEntityManagementFacilitiesRoute: typeof AuthEntityManagementFacilitiesRoute
  AuthEntityManagementLocationsRoute: typeof AuthEntityManagementLocationsRoute
  AuthEntityManagementPreferenceCardsRoute: typeof AuthEntityManagementPreferenceCardsRoute
  AuthEntityManagementSurgeonsRoute: typeof AuthEntityManagementSurgeonsRoute
  AuthEntityManagementTrackedAssetCatalogRoute: typeof AuthEntityManagementTrackedAssetCatalogRoute
  AuthEntityManagementTrackedAssetsRoute: typeof AuthEntityManagementTrackedAssetsRoute
  AuthEntityManagementUntrackedAssetCatalogRoute: typeof AuthEntityManagementUntrackedAssetCatalogRoute
  AuthEntityManagementIndexRoute: typeof AuthEntityManagementIndexRoute
}

const AuthEntityManagementRouteRouteChildren: AuthEntityManagementRouteRouteChildren =
  {
    AuthEntityManagementCaseTypesRoute: AuthEntityManagementCaseTypesRoute,
    AuthEntityManagementCountSheetsRoute: AuthEntityManagementCountSheetsRoute,
    AuthEntityManagementFacilitiesRoute: AuthEntityManagementFacilitiesRoute,
    AuthEntityManagementLocationsRoute: AuthEntityManagementLocationsRoute,
    AuthEntityManagementPreferenceCardsRoute:
      AuthEntityManagementPreferenceCardsRoute,
    AuthEntityManagementSurgeonsRoute: AuthEntityManagementSurgeonsRoute,
    AuthEntityManagementTrackedAssetCatalogRoute:
      AuthEntityManagementTrackedAssetCatalogRoute,
    AuthEntityManagementTrackedAssetsRoute:
      AuthEntityManagementTrackedAssetsRoute,
    AuthEntityManagementUntrackedAssetCatalogRoute:
      AuthEntityManagementUntrackedAssetCatalogRoute,
    AuthEntityManagementIndexRoute: AuthEntityManagementIndexRoute,
  }

const AuthEntityManagementRouteRouteWithChildren =
  AuthEntityManagementRouteRoute._addFileChildren(
    AuthEntityManagementRouteRouteChildren,
  )

interface AuthRouteRouteChildren {
  AuthAdminRouteRoute: typeof AuthAdminRouteRouteWithChildren
  AuthCaseScheduleRouteRoute: typeof AuthCaseScheduleRouteRouteWithChildren
  AuthEntityManagementRouteRoute: typeof AuthEntityManagementRouteRouteWithChildren
  AuthAssembleTrayRoute: typeof AuthAssembleTrayRoute
  AuthAssignToCaseRoute: typeof AuthAssignToCaseRoute
  AuthCaseCartAssemblyRoute: typeof AuthCaseCartAssemblyRoute
  AuthCaseCartAssemblyDetailRoute: typeof AuthCaseCartAssemblyDetailRoute
  AuthFindAssetRoute: typeof AuthFindAssetRoute
  AuthHelpSupportRoute: typeof AuthHelpSupportRoute
  AuthInsightsRoute: typeof AuthInsightsRoute
  AuthLiveOrRoute: typeof AuthLiveOrRoute
  AuthMuiLicenseTestRoute: typeof AuthMuiLicenseTestRoute
  AuthReleaseFromCaseRoute: typeof AuthReleaseFromCaseRoute
  AuthUserSettingsRoute: typeof AuthUserSettingsRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthAdminRouteRoute: AuthAdminRouteRouteWithChildren,
  AuthCaseScheduleRouteRoute: AuthCaseScheduleRouteRouteWithChildren,
  AuthEntityManagementRouteRoute: AuthEntityManagementRouteRouteWithChildren,
  AuthAssembleTrayRoute: AuthAssembleTrayRoute,
  AuthAssignToCaseRoute: AuthAssignToCaseRoute,
  AuthCaseCartAssemblyRoute: AuthCaseCartAssemblyRoute,
  AuthCaseCartAssemblyDetailRoute: AuthCaseCartAssemblyDetailRoute,
  AuthFindAssetRoute: AuthFindAssetRoute,
  AuthHelpSupportRoute: AuthHelpSupportRoute,
  AuthInsightsRoute: AuthInsightsRoute,
  AuthLiveOrRoute: AuthLiveOrRoute,
  AuthMuiLicenseTestRoute: AuthMuiLicenseTestRoute,
  AuthReleaseFromCaseRoute: AuthReleaseFromCaseRoute,
  AuthUserSettingsRoute: AuthUserSettingsRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  R403Route: R403Route,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
